module.exports = __webpack_public_path__ + "static/media/about-animation-all@mobile.81c0da28.svg";